import {DeliveryModeEnum} from 'modules/companies/types';
import {PaymentMethodProps} from 'modules/payment-methods/types';
import {SegmentProps} from 'modules/segments/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export enum BillingRecorencyEnum {
  WEEKLY = 'WEEKLY',
  FORTNIGHTLY = 'FORTNIGHTLY',
  MONTHLY = 'MONTHLY',
}

export interface CityProps {
  id: string;
  name: string;
  active: boolean;
  withCashback?: boolean;
  cashback?: number;
  cashbackExpiration?: number;
  state: string;
  billingRecorency: BillingRecorencyEnum;
  cityFee: number;
  segmentsIds?: string[];
  segments: SegmentProps[];
  paymentMethodsIds?: string[];
  guestPaymentMethodsIds?: string[];
  paymentMethods: PaymentMethodProps[];
  latitude?: number;
  longitude?: number;
  showAvailableDeliveriesAt?: string;
  availableDeliveriesStartsAt?: string;
  availableDeliveriesEndsAt?: string;
  mercadoPagoToken?: string;
  mercadoPagoPublicKey?: string;
  available: boolean;
  deliveryMode: DeliveryModeEnum;
  deliveryPrice: number;
  phone: string;
  orderSalesBy: OrderSalesByEnum;
}

export interface DistanceProps {
  id: string;
  deliveryPrice: number;
  deliveryManFee?: number;
  distance: number;
  operator: 'gt' | 'lte';
}

export enum OrderSalesByEnum {
  distance = 'distance',
  price_ascending = 'price_ascending',
  price_descending = 'price_descending',
  discount_ascending = 'discount_ascending',
  discount_descending = 'discount_descending',
}

export const translatedCityProps: TranslatedKeys<CityProps> = {
  name: 'Nome',
  active: 'Ativo?',
  withCashback: 'Tem cashback?',
  cashback: 'Valor do cashback',
  cashbackExpiration: 'Validade do cashback (dias)',
  state: 'Estado',
  billingRecorency: 'Recorrência do fechamento',
  cityFee: 'Porcentagem da cidade',
  segmentsIds: 'Segmentos',
  segments: 'Segmentos',
  availableDeliveriesStartsAt: 'Mostrar entregas disponíves às',
  availableDeliveriesEndsAt: 'Esconder entregas disponíves às',
  mercadoPagoToken: 'Token de acesso',
  mercadoPagoPublicKey: 'Chave pública',
  paymentMethodsIds: 'Formas de pagamento',
  guestPaymentMethodsIds: 'Formas de pagamento (convidados)',
  paymentMethods: 'Formas de pagamento',
  available: 'Disponível?',
  deliveryMode: 'Tipo de entrega',
  deliveryPrice: 'Taxa de entrega',
  phone: 'Telefone',
  orderSalesBy: 'Ordenar promoções por',
};

export const translatedDistanceProps: TranslatedKeys<DistanceProps> = {
  deliveryPrice: 'Taxa de entrega',
  deliveryManFee: 'Taxa do entregador',
  distance: 'Distância',
  operator: 'Condição',
};
